import { useCallback, useEffect, useRef, useState } from 'react';

import {
	createSingleQueryParamHook,
	useRouteActions,
} from '@confluence/route-manager/entry-points/RouteState.ts';

const DEBOUNCE_MS = 300;

const useSearchQueryParam = createSingleQueryParamHook('search');

export const useContentMetricsSearch = () => {
	const searchQuery = useSearchQueryParam() ?? '';
	const { setQueryParams } = useRouteActions();
	const [searchText, setSearchText] = useState(searchQuery);
	const debounceTimerRef = useRef<ReturnType<typeof setTimeout>>();

	const onSearchChange = useCallback(
		(value: string) => {
			setSearchText(value);

			clearTimeout(debounceTimerRef.current);
			debounceTimerRef.current = setTimeout(() => {
				const trimmed = value.trim();
				setQueryParams({ search: trimmed || undefined }, true);
			}, DEBOUNCE_MS);
		},
		[setQueryParams],
	);

	// Sync local state when URL changes externally (e.g. back/forward navigation)
	useEffect(() => {
		setSearchText(searchQuery);
	}, [searchQuery]);

	useEffect(() => {
		return () => clearTimeout(debounceTimerRef.current);
	}, []);

	return { searchText, searchQuery, onSearchChange };
};
